export default __webpack_public_path__ + "static/img/vogue_scene_animated_0115.c5fc4f2.webp";